
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { dataService } from "../../../services/data.services";


const initialState = {
    loading: true,
    error: '',
    success: '',
    dateObject:{start_date:null,end_date:null}
}
export const PayslipList = createAsyncThunk('purchase-order', async (searchParams) => {
    let res = await dataService.GetAPI(`${searchParams}`);
    return res
})
const PayslipListSlice = createSlice({

    name: 'purchase-order',
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.loading = true
        },
        DateFilter: (state, action) => {
            state.dateObject = action.payload
        }

    },
    extraReducers: {
        [PayslipList.pending]: (state) => {
            state.loading = true
            state.error = null
        },
        [PayslipList.fulfilled]: (state, action) => {
            state.loading = false;
            if(!action?.payload?.error && action?.payload?.data.status===200){
                state.List=action?.payload?.data.data;
                
            }else{
                state.error=action?.payload?.data?.message
            }
        },
        [PayslipList.rejected]: (state, { payload }) => {
            state.loading = false
            state.error = payload?.message?.message
        },
    },
})
export const { setLoading ,DateFilter} = PayslipListSlice.actions;
export default PayslipListSlice.reducer